// VendorStoreApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'VendorStore'];

// Enhance the base API service by adding entication-related tag types
const VendorStoreApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
        
        getVendorStoreByUserId: build.query({
            query: ({ userId, name = '', page = 0, size = 12 }) => {
              const params = new URLSearchParams({
                name,                  // Automatically encoded
                page: page.toString(), // Convert to string
                size: size.toString(), // Convert to string
              });
          
              // Include the userId as part of the URL
              const url = `/vendor-store/user/store/${userId}?${params.toString()}`;
              // console.log('Fetching URL:', url);  // Log the full URL
              
              return {
                url, // Append query string with userId
                method: 'GET',
              };
            },
          }),
          //// get product
          getProductByCategoryId: build.query({
            query: ({ categoryId, page = 0, size = 12 }) => {
              const params = new URLSearchParams({
                 page: page.toString(), // Convert to string
                size: size.toString(), // Convert to string
              });
          
              // Include the categoryId as part of the URL
              const url = `/products/category/${categoryId}?${params.toString()}`;
              // console.log('Fetching URL:', url);  // Log the full URL
              
              return {
                url, // Append query string with userId
                method: 'GET',
              };
            },
          }),
           //// get product
           getProductBySubCategoryId: build.query({
            query: ({ subCategoriesId, page = 0, size = 12 }) => {
              const params = new URLSearchParams({
                 page: page.toString(), // Convert to string
                size: size.toString(), // Convert to string
              });
          
              // Include the categoryId as part of the URL
              const url = `/products/subCategories/${subCategoriesId}?${params.toString()}`;
              // console.log('Fetching URL:', url);  // Log the full URL
              
              return {
                url, // Append query string with userId
                method: 'GET',
              };
            },
          }),
       
    }),
    overrideExisting: false,
  });

export default VendorStoreApi;

// Exporting hooks for each endpoint to be used in components
export const {
     useGetVendorStoreByUserIdQuery,
     useGetProductByCategoryIdQuery,
     useGetProductBySubCategoryIdQuery
 } = VendorStoreApi;


